import type { ExtractPropTypes, ExtractPublicPropTypes } from "vue";
import { FormProps } from "../../form";
import type Search from "./search.vue";

export const SearchProps = {
  ...FormProps,
  inline: {
    type: Boolean,
    default: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  showDefaultBtn: {
    type: Boolean,
    default: true,
  },
  searchBtnText: {
    type: String,
    default: "查询",
  },
  resetBtnText: {
    type: String,
    default: "重置",
  },
};

export const SearchEmits = {
  change: (prop: string, value: any, ref: any, comp: string) =>
    prop && value && ref && comp,
  search: (data: any) => data,
  reset: () => true,
};

export const excludeSearchPropsKeys: string[] = [
  "loading",
  "showDefaultBtn",
  "searchBtnText",
  "resetBtnText",
];

export type SearchPropsType = ExtractPropTypes<typeof SearchProps>;
export type SearchPublicPropsType = ExtractPublicPropTypes<typeof SearchProps>;
export type SearchInstance = InstanceType<typeof Search>;
